import { NgModule } from '@angular/core';
import { ExperienceDataModule } from '../data/di/experience-data.module';
import { ExperienceProvincesProviders } from './experience-provinces.providers';

@NgModule({
  providers: [...ExperienceProvincesProviders],
  imports: [ExperienceDataModule],
})
export class ExperienceModule {}
